import React, { useEffect, useState } from "react";
import { Tag, X } from "lucide-react";
import api from "@/lib/api";

// Site-wide strip shown while a seasonal MRQK sale is on (auto-created by the backend calendar).
export const SeasonalSaleBanner = () => {
  const [sale, setSale] = useState(null);
  const [hidden, setHidden] = useState(false);
  useEffect(() => { api.get("/public/seasonal-sale").then((r) => setSale(r.data?.code ? r.data : null)).catch(() => {}); }, []);
  if (!sale || hidden || sessionStorage.getItem(`sale_hide_${sale.code}`)) return null;
  const ends = new Date(sale.ends + "T23:59:59");
  const days = Math.max(0, Math.ceil((ends - Date.now()) / 86400000));
  return (
    <div className="bg-[#FFC107] text-black text-xs sm:text-sm py-2 px-4 flex items-center justify-center gap-3 relative" data-testid="seasonal-sale-banner">
      <Tag className="w-4 h-4 shrink-0" />
      <span><b>{sale.name}:</b> {sale.blurb} Use code <b className="tracking-wider" data-testid="seasonal-sale-code">{sale.code}</b> at checkout{days > 0 ? ` · ${days} day${days === 1 ? "" : "s"} left` : " · ends tonight"}.</span>
      <button onClick={() => { sessionStorage.setItem(`sale_hide_${sale.code}`, "1"); setHidden(true); }} className="absolute right-3 top-1/2 -translate-y-1/2 p-1 hover:opacity-70" aria-label="Hide" data-testid="seasonal-sale-hide"><X className="w-4 h-4" /></button>
    </div>
  );
};
